import { FormBuilder, Validators } from '@angular/forms';
import { MatSort, MatPaginator } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { format, isBefore, isSameDay, isValid } from 'date-fns';
import { DataTableSource } from '../../classes/DataTableSource/datatablesource';
import { ApplicationService } from '../../services/application/application.service';
import { DialogService } from '../../services/dialogs/dialogs.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService } from '../../services/user/user.service';
import { CollegeSchoolYearPipe } from '../../pipes/collegeschoolyear.pipe';
import { CollegeTermPipe } from '../../pipes/collegeterm.pipe';
var ManageTermsComponent = /** @class */ (function () {
    function ManageTermsComponent(appService, collegeSchoolYearPipe, collegeTermPipe, dialogService, errorService, fb, mediaChange, splashService, userService) {
        this.appService = appService;
        this.collegeSchoolYearPipe = collegeSchoolYearPipe;
        this.collegeTermPipe = collegeTermPipe;
        this.dialogService = dialogService;
        this.errorService = errorService;
        this.fb = fb;
        this.mediaChange = mediaChange;
        this.splashService = splashService;
        this.userService = userService;
        this._subrelease = new Subject();
        this.AllHeaders = ['CollegeYear', 'TermCode', 'Term', 'DateBegin', 'DateEnd', 'Actions'];
        this.CollegeTermChoices = [{ TermCode: '1' }, { TermCode: '2' }, { TermCode: '3' }];
    }
    ManageTermsComponent.prototype.ngOnInit = function () {
        var self = this;
        self.AdminCollege = null;
        self.Colleges = null;
        self.NoData = false;
        self.PartialViewReady = false;
        self.ShowingTermEntryPanel = false;
        self.TermsList = null;
        self.TermsData = new DataTableSource([], self.paginator, self.sorter, self.SortTerms.bind(self));
        self.User = null;
        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
        });
        // Setup the form group
        self.TermEntryForm = self.fb.group({
            CollegeSchoolYear: ['', Validators.required],
            TermCode: ['', Validators.required],
            DateBegin: [null, Validators.required],
            DateEnd: [null, Validators.required],
            TermWindowID: [null],
        });
        // Get the first non-null UserInfo object so we can begin setting up the component
        self.userService.UserSubject.pipe(takeUntil(self._subrelease), first(function (user) { return user && !!user.AuthToken; })).subscribe(function (user) {
            self.User = user;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load static data for use in the compoment.
            var collegeObs = self.appService.GetAllColleges(self.User.AuthToken);
            var allCollegeYearsObs = self.appService.GetAllCollegeYears();
            var adminCollegeObs = self.appService.SelectedAdminCollegeIDSubject;
            combineLatest(collegeObs, allCollegeYearsObs, adminCollegeObs, function (colleges, collegeyears, adminCollegeID) {
                return {
                    AdminCollegeID: adminCollegeID,
                    Colleges: colleges,
                    CollegeYears: collegeyears,
                };
            })
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (packet) {
                self.Colleges = packet.Colleges;
                self.AllCollegeYears = packet.CollegeYears;
                self.AdminCollegeID = packet.AdminCollegeID;
                self.AdminCollege = null;
                if (self.AdminCollegeID != null && self.Colleges) {
                    self.AdminCollege = self.Colleges.find(function (item) {
                        return item.CollegeID === self.AdminCollegeID;
                    });
                }
                // If no college is selected, try to pre-select a college, deferring to Polk State if available.
                // if (self.AdminCollegeID != null && self.Colleges) {
                //     self.AdminCollege = self.Colleges.find(item => {return item.CollegeID == 2;});
                //     if (!self.AdminCollege) self.AdminCollege = self.Colleges[0];
                // }
                // Load the terms for this college, if one has been selected.
                if (self.AdminCollege) {
                    self.appService.GetAvailableTerms(self.User.AuthToken, self.AdminCollege.CollegeID).subscribe(function (terms) {
                        self.TermsList = terms;
                        if (!self.TermsList || !self.TermsList.length) {
                            self.NoData = true;
                            // Put in a fake record to trip the display message
                            self.TermsData.dataChange.next([{}]);
                        }
                        else {
                            self.NoData = false;
                            self.TermsData.dataChange.next(self.TermsList);
                        }
                        self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
                        self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
                        // Ready for component use.
                        self.PartialViewReady = true;
                    }, function (error) {
                        self.errorService.HandleServiceError(error);
                    });
                }
                else {
                    // No college selected. Release component for viewing.
                    self.PartialViewReady = true;
                }
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    ManageTermsComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    // #region Add Term Cancel Handler Method
    ManageTermsComponent.prototype.AddTermCancelHandler = function () {
        var self = this;
        // Null out the form, then close the panel.
        self.TermEntryForm.reset();
        self.ShowingTermEntryPanel = false;
    };
    // #endregion
    // #region Add Term Handler Method
    ManageTermsComponent.prototype.AddTermHandler = function () {
        var self = this;
        var form = self.TermEntryForm.getRawValue();
        if (!form) {
            return;
        }
        // Validate that the dates are in proper ordering (DateBegin <= DateEnd)
        if (!form.DateBegin || !isValid(form.DateBegin)) {
            self.splashService.SnackbarError('Term beginning date is missing or invalid.');
            return;
        }
        if (!form.DateEnd || !isValid(form.DateEnd)) {
            self.splashService.SnackbarError('Term ending date is missing or invalid.');
            return;
        }
        var dateend = form.DateEnd;
        var datebegin = form.DateBegin;
        if (isBefore(dateend, datebegin) || isSameDay(dateend, datebegin)) {
            self.splashService.SnackbarError('Term ending date is set as before or on the same day as the beginning date.');
            return;
        }
        // Get a confirmation
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You are about to add the following new college term window for " + self.AdminCollege.CollegeName + ":<br /><br />\n            <strong>College School Year: </strong>" + self.collegeSchoolYearPipe.transform(form.CollegeSchoolYear, self.AdminCollege.CollegeID) + "<br />\n            <strong>Term: </strong>" + self.collegeTermPipe.transform(form.TermCode) + "<br />\n            <strong>Term Code: </strong>" + form.TermCode + "<br />\n            <strong>Beginning Date: </strong>" + format(form.DateBegin, 'M/DD/YYYY') + "<br />\n            <strong>Ending Date: </strong>" + format(form.DateEnd, 'M/DD/YYYY') + "<br /><br />Are you sure you wish to continue?",
            OKText: 'Yes - Add Term',
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (result) {
            if (result === true) {
                // User has opted to proceed. Signal the system to add the term window to the college.
                self.appService
                    .AddTermWindowToCollege(self.User.AuthToken, self.AdminCollege.CollegeID, form.CollegeSchoolYear, form.TermCode, form.DateBegin, form.DateEnd)
                    .subscribe(function (terms) {
                    // Toast the success
                    self.splashService.SnackbarSuccess('New college term window added successfully.');
                    // Update the list of known college terms
                    self.TermsList = terms;
                    self.TermsData.Update(terms);
                    // Reset the term form
                    self.TermEntryForm.reset();
                    // Hide the panel
                    self.ShowingTermEntryPanel = false;
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Remove Term Method
    ManageTermsComponent.prototype.RemoveTerm = function (term) {
        var self = this;
        if (!term) {
            return;
        }
        // Get a confirmation
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You have chosen to remove the following college term window for " + self.AdminCollege.CollegeName + ":<br /><br />\n            <strong>College School Year: </strong>" + self.collegeSchoolYearPipe.transform(term.CollegeSchoolYear, self.AdminCollege.CollegeID) + "<br />\n            <strong>Term: </strong>" + self.collegeTermPipe.transform(term.TermCode) + "<br />\n            <strong>Term Code: </strong>" + term.TermCode + "<br />\n            <strong>Beginning Date: </strong>" + format(term.DateBegin, 'M/DD/YYYY') + "<br />\n            <strong>Ending Date: </strong>" + format(term.DateEnd, 'M/DD/YYYY') + "<br /><br />Once removed, this term window must be added again in order for students to have access " +
                "to making new requests for this college term. Are you sure you wish to continue?",
            OKText: 'Yes - Remove Term',
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (result) {
            if (result === true) {
                // User has opted to proceed. Signal the system to remove this term window from the college.
                self.appService.RemoveTermWindowFromCollege(self.User.AuthToken, term.TermWindowID).subscribe(function (terms) {
                    // Toast the success
                    self.splashService.SnackbarSuccess('College term window was removed successfully.');
                    // Update the list of known college terms
                    self.TermsList = terms;
                    self.TermsData.Update(terms);
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Show Term Entry Editor Panel Method
    ManageTermsComponent.prototype.ShowTermEntryEditorPanel = function (term) {
        var self = this;
        // Set up the formgroup to prepare for editing. If we were provided a college term, use those values to prefill the formgroup.
        if (term) {
            var newform = {
                CollegeSchoolYear: term.CollegeSchoolYear,
                TermCode: term.TermCode,
                DateBegin: term.DateBegin,
                DateEnd: term.DateEnd,
                TermWindowID: term.TermWindowID,
            };
            // Patch the values
            self.TermEntryForm.patchValue(newform);
            // Set disabled elements
            self.TermEntryForm.get('CollegeSchoolYear').disable();
            self.TermEntryForm.get('TermCode').disable();
        }
        else {
            // Clear the form
            var newform = {
                CollegeSchoolYear: '',
                TermCode: '',
                DateBegin: null,
                DateEnd: null,
                TermWindowID: null,
            };
            self.TermEntryForm.patchValue(newform);
            // Enable all elements
            self.TermEntryForm.get('CollegeSchoolYear').enable();
            self.TermEntryForm.get('TermCode').enable();
        }
        self.TermEntryForm.updateValueAndValidity({ emitEvent: false });
        self.ShowingTermEntryPanel = true;
    };
    // #endregion
    // #region Sort Terms Method
    ManageTermsComponent.prototype.SortTerms = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'CollegeYear':
                _a = [First.CollegeSchoolYear, Second.CollegeSchoolYear], PropA = _a[0], PropB = _a[1];
                break;
            case 'TermCode':
                _b = [First.TermCode, Second.TermCode], PropA = _b[0], PropB = _b[1];
                break;
            case 'Term':
                _c = [self.collegeTermPipe.transform(First.TermCode), self.collegeTermPipe.transform(Second.TermCode)], PropA = _c[0], PropB = _c[1];
                break;
            case 'DateBegin':
                _d = [First.DateBegin, Second.DateBegin], PropA = _d[0], PropB = _d[1];
                break;
            case 'DateEnd':
                _e = [First.DateEnd, Second.DateEnd], PropA = _e[0], PropB = _e[1];
                break;
        }
        if (PropA instanceof Date) {
            return (isBefore(PropA, PropB) ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        else {
            var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
            var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
            return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        var _a, _b, _c, _d, _e;
    };
    // #endregion
    // #region Update Term Handler Method
    ManageTermsComponent.prototype.UpdateTermHandler = function () {
        var self = this;
        var form = self.TermEntryForm.getRawValue();
        if (!form) {
            return;
        }
        // Validate that the dates are in proper ordering (DateBegin <= DateEnd)
        if (!form.DateBegin || !isValid(form.DateBegin)) {
            self.splashService.SnackbarError('Term beginning date is missing or invalid.');
            return;
        }
        if (!form.DateEnd || !isValid(form.DateEnd)) {
            self.splashService.SnackbarError('Term ending date is missing or invalid.');
            return;
        }
        var dateend = form.DateEnd;
        var datebegin = form.DateBegin;
        if (isBefore(dateend, datebegin) || isSameDay(dateend, datebegin)) {
            self.splashService.SnackbarError('Term ending date is set as before or on the same day as the beginning date.');
            return;
        }
        // Get a confirmation
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You are about to update the following college term window for " + self.AdminCollege.CollegeName + ":<br /><br />\n            <strong>College School Year: </strong>" + self.collegeSchoolYearPipe.transform(form.CollegeSchoolYear, self.AdminCollege.CollegeID) + "<br />\n            <strong>Term: </strong>" + self.collegeTermPipe.transform(form.TermCode) + "<br />\n            <strong>Term Code: </strong>" + form.TermCode + "<br />\n            <strong>Beginning Date: </strong>" + format(form.DateBegin, 'M/DD/YYYY') + "<br />\n            <strong>Ending Date: </strong>" + format(form.DateEnd, 'M/DD/YYYY') + "<br /><br />Are you sure you wish to continue?",
            OKText: 'Yes - Update Term',
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (result) {
            if (result === true) {
                // User has opted to proceed. Signal the system to add the term window to the college.
                self.appService
                    .UpdateTermWindowForCollege(self.User.AuthToken, form.TermWindowID, form.CollegeSchoolYear, form.TermCode, form.DateBegin, form.DateEnd)
                    .subscribe(function (terms) {
                    // Toast the success
                    self.splashService.SnackbarSuccess('College term window updated successfully.');
                    // Update the list of known college terms
                    self.TermsList = terms;
                    self.TermsData.Update(terms);
                    // Reset the term form
                    self.TermEntryForm.reset();
                    // Hide the panel
                    self.ShowingTermEntryPanel = false;
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    return ManageTermsComponent;
}());
export { ManageTermsComponent };



// WEBPACK FOOTER //
// ./src/app/manageterms/manageterms.component.ts.pre-build-optimizer.js